import { useEffect, useState } from 'react';

function hhmm(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
}

/**
 * مدة الجلسة على الشاشة، محسوبة محلياً كل ثانية فلا تحتاج إعادة تحميل.
 *
 * المصدر: startTime (البداية الحقيقية) و endTime (نهاية الباقة المحسوبة على
 * الخادم، وتتحرّك مع التمديد). جلسة بلا endTime — ساعية/ثابتة/مفتوحة أو طفل
 * باشتراك شهري — لا مدة لها فلا تُعلَّم متجاوزة أبداً.
 *
 * بعد استهلاك المدة لا يستمر العدّاد بصمت: isOver يصير true ويُعرَض زمن
 * التجاوز. الجلسة تبقى نشطة والوقت الإضافي يُحتسب عند المحاسبة كما هو.
 */
export function useSessionDuration(session, tickMs = 1000) {
  const [now, setNow] = useState(() => Date.now());

  const startRaw = session && session.startTime ? new Date(session.startTime).getTime() : null;
  const covered = !!(session && session.subscriptionCovered);
  const endRaw = !covered && session && session.endTime ? new Date(session.endTime).getTime() : null;

  useEffect(() => {
    if (!startRaw) return undefined;
    const id = setInterval(() => setNow(Date.now()), tickMs);
    return () => clearInterval(id);
  }, [startRaw, endRaw, tickMs]);

  if (!startRaw || Number.isNaN(startRaw)) {
    return {
      hasDuration: false,
      isOver: false,
      elapsedSeconds: 0,
      remainingSeconds: 0,
      overSeconds: 0,
      elapsed: '00:00:00',
      remaining: '00:00:00',
      over: '00:00:00',
      durationMinutes: 0,
      expectedEndTime: null
    };
  }

  const elapsedSeconds = Math.max(0, Math.floor((now - startRaw) / 1000));
  const hasDuration = !!endRaw && Number.isFinite(endRaw) && endRaw > startRaw;
  const remainingSeconds = hasDuration ? Math.max(0, Math.floor((endRaw - now) / 1000)) : 0;
  const overSeconds = hasDuration ? Math.max(0, Math.floor((now - endRaw) / 1000)) : 0;

  return {
    hasDuration,
    isOver: hasDuration && now >= endRaw,
    elapsedSeconds,
    remainingSeconds,
    overSeconds,
    elapsed: hhmm(elapsedSeconds),
    remaining: hhmm(remainingSeconds),
    over: hhmm(overSeconds),
    durationMinutes: hasDuration ? Math.round((endRaw - startRaw) / 60000) : 0,
    expectedEndTime: hasDuration ? new Date(endRaw) : null
  };
}

export default useSessionDuration;
